export default __webpack_public_path__ + "static/equilibre_video-bd34cda644220977f6509cedb3644d52.mp4";